import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

import { FormInputProps } from "../types";

interface ITextProps extends FormInputProps {
  variant?: "filled" | "outlined";
  multiline?: boolean;
  rows?: number;
  minRows?: number;
  hiddenLabel?: boolean;
  type?: string;
  onBlur?: any;
  onFocus?: any;
  defaultValue?: any;
  inputRef?: any;
  disabled?: boolean;
  readOnly?: boolean;
  validate?: any;
}

export function FormTextInput({
  name,
  control,
  label,
  required,
  pattern,
  placeholder,
  mask,
  multiline,
  maxLength,
  shrink,
  autoFocus,
  rows,
  variant,
  hiddenLabel,
  type,
  onBlur,
  onFocus,
  defaultValue,
  inputRef,
  minRows,
  disabled,
  readOnly,
  validate,
}: ITextProps) {
  return (
    <Controller
      defaultValue={defaultValue}
      name={name}
      control={control}
      rules={{
        required,
        pattern,
        validate,
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          type={type}
          multiline={multiline ? true : false}
          sx={{
            "& .MuiFilledInput-root": { backgroundColor: "neutral100.main" },
          }}
          autoFocus={autoFocus}
          placeholder={placeholder || ""}
          InputLabelProps={{
            shrink:
              shrink !== undefined
                ? shrink
                : value !== "" && value !== null && value !== undefined
                ? true
                : undefined,
          }}
          minRows={minRows}
          rows={rows}
          helperText={error ? error.message : null}
          size="medium"
          error={error !== undefined}
          onChange={(e: any) => {
            const formattedValue = mask ? mask(e.target.value) : e.target.value;
            onChange(formattedValue);
          }}
          onBlur={onBlur}
          inputRef={inputRef}
          value={mask ? mask(value) : value}
          label={label}
          inputProps={{ maxLength, readOnly }}
          fullWidth
          variant={variant === "outlined" ? "outlined" : "filled"}
          hiddenLabel={hiddenLabel || false}
          onFocus={onFocus}
          disabled={disabled}
        />
      )}
    />
  );
}
